var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3RdSectionBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1799,
    height: 1879,
    viewBox: "0 0 1799 1879",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2514_43092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.208 1364.33C800.517 1364.33 705.11 1225.8 705.11 1054.91C705.11 884.024 800.517 745.494 918.208 745.494C1035.9 745.494 1131.31 884.024 1131.31 1054.91C1131.31 1225.8 1035.9 1364.33 918.208 1364.33Z",
    fill: "#FEBE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.93 1449.21C1038.24 1449.21 942.829 1310.67 942.829 1139.79C942.829 968.904 1038.24 830.374 1155.93 830.374C1273.62 830.374 1369.02 968.904 1369.02 1139.79C1369.02 1310.67 1273.62 1449.21 1155.93 1449.21Z",
    fill: "#DE2BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.448 1214.74C524.757 1214.74 429.35 1076.21 429.35 905.324C429.35 734.438 524.757 595.908 642.448 595.908C760.138 595.908 855.545 734.438 855.545 905.324C855.545 1076.21 760.138 1214.74 642.448 1214.74Z",
    fill: "#24EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.76 1048.74C1038.07 1048.74 942.659 910.212 942.659 739.327C942.659 568.441 1038.07 429.911 1155.76 429.911C1273.45 429.911 1368.85 568.441 1368.85 739.327C1368.85 910.212 1273.45 1048.74 1155.76 1048.74Z",
    fill: "#FF6D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.805 1315.44C874.115 1315.44 778.708 1176.91 778.708 1006.03C778.708 835.14 874.115 696.61 991.805 696.61C1109.5 696.61 1204.9 835.14 1204.9 1006.03C1204.9 1176.91 1109.5 1315.44 991.805 1315.44Z",
    fill: "#ADFF99"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2514_43092",
    x: 0.36911,
    y: 0.930298,
    width: 1797.64,
    height: 1877.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 214.49,
    result: "effect1_foregroundBlur_2514_43092"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3RdSectionBg);
export default __webpack_public_path__ + "static/media/3rd-section-bg.4a7ef5fd610c5fbd8abfe74c9b5bc5a5.svg";
export { ForwardRef as ReactComponent };